import { useState } from "react";
import { ApiError, getHost, ping, setHost, setToken } from "../api";

export default function Login({ onAuthed }: { onAuthed: () => void }) {
  const [token, setTok] = useState("");
  const [host, setHostInput] = useState(getHost());
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    setHost(host.trim());
    setToken(token.trim());
    try {
      await ping();
      onAuthed();
    } catch (e) {
      setErr(e instanceof ApiError ? `${e.status} ${e.body.slice(0, 200)}` : (e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-full items-center justify-center bg-ink-50 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-ink-900 text-white font-mono text-sm">aem</div>
          <h1 className="text-lg font-semibold text-ink-900">auto-email-marketer</h1>
          <p className="mt-1 text-sm text-ink-500">Sign in with your API bearer token.</p>
        </div>
        <form onSubmit={submit} className="card p-5 space-y-4">
          <div>
            <label className="label">Worker URL</label>
            <input
              type="url"
              className="input"
              value={host}
              onChange={(e) => setHostInput(e.target.value)}
              placeholder="https://auto-email-marketer.account.workers.dev"
            />
          </div>
          <div>
            <label className="label">Bearer Token</label>
            <input
              type="password"
              className="input font-mono"
              value={token}
              onChange={(e) => setTok(e.target.value)}
              placeholder="paste API_BEARER_TOKEN"
              autoFocus
            />
          </div>
          {err && (
            <div className="rounded-md border border-red-200 bg-red-50 p-3 text-xs text-red-700 font-mono">
              {err}
            </div>
          )}
          <button type="submit" className="btn-primary w-full" disabled={busy || !token.trim()}>
            {busy ? "checking…" : "Sign in"}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-ink-400">
          Stored in this browser only. Wipe with browser dev-tools → Application → localStorage.
        </p>
      </div>
    </div>
  );
}
